import React, { useMemo } from "react";
import { ArrowLeftOutlined, ArrowRightOutlined, CheckCircleFilled } from "@ant-design/icons";
import { Button, Col, Radio, Row } from "antd";
import { getGuidFirst8 } from "@/utils/utils";
const ETAInputNavBar = ({ shipmentsList, currentShipmentData, currentShipmentETAInputIndex, decrementCurrentShipmentETAInputIndex, incrementCurrentShipmentETAInputIndex, setCurrentShipmentETAInputIndex, }) => {
    const nextIndexToValidate = useMemo(() => {
        const nextUnvalidatedIndex = shipmentsList.findIndex(s => !s.etasValidated);
        return nextUnvalidatedIndex ?? -1;
    }, [shipmentsList]);
    return (React.createElement(Row, { justify: "space-between", style: {
            marginBottom: 32,
            border: "1px solid #d9d9d9",
            backgroundColor: "rgb(252, 252, 252)",
            borderRadius: 20,
        } },
        React.createElement(Col, { style: { marginRight: "2%" } },
            React.createElement(Button, { onClick: decrementCurrentShipmentETAInputIndex, disabled: currentShipmentETAInputIndex === 0, icon: React.createElement(ArrowLeftOutlined, null), type: "primary" })),
        React.createElement(Col, null,
            React.createElement(Radio.Group, { buttonStyle: "solid", value: currentShipmentData.id, onChange: e => {
                    const newSelectedShipmentId = e.target.value;
                    const indexOfSelectedShipment = shipmentsList.findIndex(s => s.id === newSelectedShipmentId);
                    setCurrentShipmentETAInputIndex(indexOfSelectedShipment);
                } }, shipmentsList.map(({ id, etasValidated }, i) => (React.createElement(Radio.Button, { key: id, value: id, disabled: !etasValidated && nextIndexToValidate !== i },
                getGuidFirst8(id),
                etasValidated && React.createElement(CheckCircleFilled, { style: { color: "#52c41a", marginLeft: 5 } })))))),
        React.createElement(Col, { style: { marginLeft: "2%" } },
            React.createElement(Button, { onClick: incrementCurrentShipmentETAInputIndex, disabled: currentShipmentETAInputIndex + 1 === shipmentsList.length || !currentShipmentData.etasValidated, icon: React.createElement(ArrowRightOutlined, null), type: "primary" }))));
};
export default ETAInputNavBar;
